/* =====================================================================
   UUGI Trust Strip — Animated counters

   TrustStrip.cshtml emits data-count/data-suffix/data-decimals only when a
   Trust Item's value opens with a number, so "300+" counts while "Gold" does
   not. The strip sits mid-page, so counters run on scroll-in rather than on
   the hero's timer in script-v4.js.
   ===================================================================== */

$(function () {

  function animateCounter($el, target, suffix, decimals, dur) {
    dur = dur || 1800;
    var pow = Math.pow(10, decimals);
    var fmt = { minimumFractionDigits: decimals, maximumFractionDigits: decimals };
    var start = performance.now();
    function draw(v) { $el.text(v.toLocaleString('en-IN', fmt) + suffix); }
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      draw(Math.floor(eased * target * pow) / pow);
      if (t < 1) requestAnimationFrame(tick);
      else draw(target);
    }
    requestAnimationFrame(tick);
  }

  function runCountersIn(section) {
    if (section.__ran) return;
    section.__ran = true;
    $(section).find('.trust__item strong[data-count]').each(function () {
      var $s = $(this);
      animateCounter($s, parseFloat($s.attr('data-count')) || 0,
        $s.attr('data-suffix') || '', parseInt($s.attr('data-decimals'), 10) || 0);
    });
  }

  var $trustSections = $('.trust');
  if ($trustSections.length && 'IntersectionObserver' in window) {
    var trustObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { runCountersIn(e.target); trustObs.unobserve(e.target); } });
    }, { threshold: 0.35 });
    $trustSections.each(function () { trustObs.observe(this); });
  } else {
    $trustSections.each(function () { runCountersIn(this); });
  }

});
